export default {
    pagenumber: ["當前第", "頁", "共", "頁"],
    prev: "上一頁",
    next: "下一頁",
    error: "檔案加載失敗",
    openInNewWindow: "新視窗開啟",
    continuousMode: "連續模式",
    paginatedMode: "分頁模式",
};
